<template>
  <page-table />
</template>
<script>
import PageTable from './components/table'
export default {
  name: 'ecom-awsSample-sampleInfo',
  components: {
    PageTable,
  },
}
</script>
